<template>
  <div v-if="isLoading" class="table_loading">
    <div>
      <svg viewBox="25 25 50 50" class="circular">
        <circle cx="50" cy="50" r="20" fill="none" stroke-width="5" stroke-miterlimit="10" class="path"></circle>
      </svg>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'components-custom-loading',
    props: {
      isLoading: {
        type: Boolean,
        default: true
      }
    }
  }
</script>

<style lang='scss' scoped>
  .table_loading{
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(255,255,255,0.9);
  }
  .table_loading>div{
    width: 35px;
    height: 35px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
</style>


// WEBPACK FOOTER //
// src/components-base/components-custom/loading/loading.vue